import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_MY_API_ACCESS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/my-api-access',
        iconClass: 'fas fa-key',
        name: '::Menu:PublicApiCustomer',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.PublicApiCustomer.Self',
        order: 14,
      },
    ]);
  };
}
